// Adapter: maps the Base44 SDK surface used by Voult onto CITIDAN /api/voult endpoints.
import api, { setToken } from "@/lib/api";

const sortRows = (rows, sort, limit) => {
  let out = Array.isArray(rows) ? [...rows] : [];
  if (sort) {
    const desc = sort.startsWith("-");
    const k = sort.replace(/^-/, "");
    out.sort((a, b) => String(a[k] ?? "").localeCompare(String(b[k] ?? "")) * (desc ? -1 : 1));
  }
  return limit ? out.slice(0, limit) : out;
};

const rest = (base) => ({
  async list(sort, limit) { return sortRows((await api.get(base)).data, sort, limit); },
  async filter(q = {}) {
    const rows = (await api.get(base)).data || [];
    return rows.filter((r) => Object.entries(q).every(([k, v]) => r[k] === v));
  },
  async get(id) { return (await api.get(`${base}/${id}`)).data; },
  async create(p) { return (await api.post(base, p)).data; },
  async update(id, p) { return (await api.put(`${base}/${id}`, p)).data; },
  async delete(id) { await api.delete(`${base}/${id}`); return true; },
});

const entity = (name) => rest(`/voult/entities/${name}`);

export const base44 = {
  entities: {
    Card: rest("/voult/cards"),
    ActivityLog: entity("ActivityLog"),
    IntegrationKey: entity("IntegrationKey"),
    MerchantAccess: entity("MerchantAccess"),
    SecurityEvent: entity("SecurityEvent"),
    VaultSettings: entity("VaultSettings"),
    PaymentTransaction: {
      async list(sort, limit) { return sortRows((await api.get("/voult/payments")).data, sort, limit); },
    },
  },
  auth: {
    async me() {
      const { data } = await api.get("/auth/me");
      return { ...data, full_name: data.full_name || data.name || data.email };
    },
    logout() { setToken(null); window.location.href = "/"; },
  },
};

export const voultCheckout = async (payload) => (await api.post("/voult/checkout", payload)).data;
export const voultRefund = async (id, payload) => (await api.post(`/voult/payments/${id}/refund`, payload)).data;
